import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/public/images/chauffeur-services.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/public/images/homepageimg.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/components/ChauffeurServicesFleet.jsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/components/globalSearch/GlobalSearch.jsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/components/GoldLinkButton.jsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/components/heroSection/heroSection.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/components/globalSearch/globalSearch.scss");
